import { createIcon } from '~/utils';

export const MasterCardIcon = createIcon({
  viewBox: '0 0 32 20',
  path: [
    <path
      fill='#ff5f00'
      d='M20.3262 2.13965H11.6738V17.8619H20.3262V2.13965Z'
    />,
    <path
      fill='#eb001b'
      d='M12.223 10.0004C12.223 6.9448 13.6238 4.02814 15.9861 2.13925C11.7011 -1.27742 5.46589 -0.527419 2.08735 3.83369C-1.26372 8.16703 -0.522091 14.4448 3.79036 17.8615C7.38864 20.7226 12.4152 20.7226 16.0135 17.8615C13.6238 15.9726 12.223 13.0559 12.223 10.0004Z'
    />,
    <path
      fill='#f79e1b'
      d='M31.9999 10.0004C31.9999 15.5281 27.5776 20.0004 22.1115 20.0004C19.8866 20.0004 17.7441 19.2504 16.0137 17.8615C20.2987 14.4448 21.0403 8.16702 17.6617 3.80591C17.1673 3.1948 16.618 2.61147 16.0137 2.13925C20.2987 -1.27742 26.5338 -0.527419 29.8849 3.83369C31.2583 5.58369 31.9999 7.75036 31.9999 10.0004Z'
    />,
  ],
});
